// extracted by mini-css-extract-plugin
export default {"wrapper":"jobs_page__wrapper--kdWu","job":"jobs_page__job--SJZ-"};